export const checkIsCountdownPass = (masterPass) => {
  const displayFormat = masterPass.content.description_json.DisplayFormat;
  return displayFormat != null && displayFormat == "countdown";
}